import React from "react";
import { CHECKOUT_URL, thingsThatChange } from "../data/landing";
export function FinalCta() {
  return <section className="bg-surface" data-id="element-62" data-mp="vfza9xptsf2b">
      <div id="comprar" className="mx-auto max-w-4xl scroll-mt-28 px-6 py-24 text-center md:py-32" data-id="element-63" data-mp="vh0o29y87fnq">
        <p className="text-muted" data-id="element-64" data-mp="19ga2p56sa1pl">{thingsThatChange.join(" · ")} pueden cambiar.</p>
        <h2 className="mt-6 font-serif text-4xl leading-tight text-cream md:text-6xl" data-id="element-65" data-mp="15bsnzkfa6elo">
          Tu mente es el único activo que{" "}
          <span className="text-gold" data-id="element-66" data-mp="1ee1w63n2tvvw">la inflación no puede tocar.</span>
        </h2>
        <p className="mx-auto mt-8 max-w-2xl leading-relaxed text-muted" data-id="element-67" data-mp="1ebxttq4tt4xq">
          Una invitación a dejar de vivir con la mente secuestrada por la crisis. Para prosperar
          sin negar la realidad, desarrollar calma sin volverte indiferente y manifestar desde la
          acción, no desde la ilusión.
        </p>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-10 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-gold px-8 py-4 text-base font-semibold text-ink transition-colors duration-150 hover:bg-gold-light focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-68" data-mp="1x4jow87wsrh9">
          Acceder por $4.990 ARS
        </a>
      </div>
    </section>;
}